import { motion } from "framer-motion";
import { IdCard, Percent, Map, Bell, Info } from "lucide-react";
import { IMAGES, LINKS } from "../../data/content";

const features = [
  { icon: IdCard, label: "Legitimația digitală mereu cu tine" },
  { icon: Percent, label: "Reduceri la un tap distanță" },
  { icon: Map, label: "Hartă cu beneficii din apropiere" },
  { icon: Bell, label: "Notificări utile despre oferte, campanii și concursuri" },
];

export const AliveApp = () => (
  <section id="alive-app" className="bg-brand-dark py-16 md:py-24 relative overflow-hidden" data-testid="alive-app-section">
    <div className="absolute -bottom-32 -left-32 w-[480px] h-[480px] rounded-full bg-white/5 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, x: -24 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="order-2 lg:order-1"
      >
        <img
          src={IMAGES.aliveApp}
          alt="Alive App — legitimația digitală ISIC"
          data-testid="alive-app-screenshot"
          className="w-full max-w-xl lg:max-w-2xl mx-auto drop-shadow-2xl"
        />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="order-1 lg:order-2"
      >
        <h2 className="font-heading font-black text-3xl md:text-4xl tracking-tight text-white">
          Ai legitimația și reducerile în Alive App
        </h2>
        <p className="mt-5 text-base md:text-lg text-teal-50/90 leading-relaxed">
          Pentru o experiență și mai simplă, descarcă Alive App. Acolo ai legitimația
          ISIC în format digital, găsești beneficiile ISIC într-un singur loc și vezi
          rapid cum le poți folosi.
        </p>
        <ul className="mt-8 space-y-4">
          {features.map((f, i) => (
            <li key={f.label} data-testid={`alive-feature-${i}`} className="flex items-center gap-3 text-white">
              <span className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                <f.icon className="w-4.5 h-4.5 text-teal-100" style={{ width: 18, height: 18 }} />
              </span>
              <span className="text-sm md:text-base font-medium">{f.label}</span>
            </li>
          ))}
        </ul>
        <div className="mt-8 flex flex-wrap items-center gap-4">
          <a href={LINKS.appStore} target="_blank" rel="noopener noreferrer" data-testid="app-store-btn" className="hover:-translate-y-0.5 transition-transform duration-300">
            <img src={IMAGES.appStore} alt="Descarcă din App Store" className="h-12" />
          </a>
          <a href={LINKS.googlePlay} target="_blank" rel="noopener noreferrer" data-testid="google-play-btn" className="hover:-translate-y-0.5 transition-transform duration-300">
            <img src={IMAGES.googlePlay} alt="Descarcă din Google Play" className="h-12" />
          </a>
        </div>
        <div
          data-testid="alive-app-disclaimer"
          className="mt-8 flex items-start gap-3 rounded-2xl bg-white/10 border border-white/15 p-4"
        >
          <Info className="w-5 h-5 text-teal-100 shrink-0 mt-0.5" />
          <p className="text-xs md:text-sm text-teal-50/90 leading-relaxed">
            Alive App oferă acces strict la legitimația și beneficiile ISIC. Cardul BRD-ISIC
            nu apare în Alive App, iar aplicația nu are acces la componenta bancară a cardului.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);
